import React, { ChangeEvent, useState } from "react";
import { Box, Card, Typography, TextField, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import AuthLayout from "./authLayout";
import useAuth from "../../hooks/useAuth";

const Signup: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const { signUp } = useAuth();

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(PATHS.AUTH_ACCOUNT_MAIL_SEND);
  };

  return (
    <AuthLayout>
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 2,
          display: "flex",
          flexDirection: "column",
          maxWidth: "450px",
          width: "100%",
        }}
      >
        <Box
          width={"100%"}
          paddingInline={2}
          display={"flex"}
          flexDirection={"column"}
          gap={1}
        >
          <Typography variant="h5" paddingBlock={2} align="center">
            サインアップ
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <TextField
                fullWidth
                value={email}
                type="text"
                onChange={handleEmailChange}
                label="メールアドレス"
              />
              <Button
                sx={{ height: "42px" }}
                type="submit"
                variant="contained"
                fullWidth
              >
                アカウント作成
              </Button>
            </Box>
          </form>
          {/* <Box marginTop={1}>
            <Typography variant="body2" align="center">
              ※アカウント作成をクリックすることで
              <Link
                component="button"
                variant="body2"
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "rgba(9, 69, 88, 0.4)",
                  color: "inherit",
                }}
              >
                利用規約
              </Link>
              、
              <Link
                component="button"
                variant="body2"
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "rgba(9, 69, 88, 0.4)",
                  color: "inherit",
                }}
              >
                プライバシーポリシー
              </Link>
              に同意するものとします。
            </Typography>
          </Box> */}
          <Button
            variant="text"
            onClick={() => navigate(PATHS.AUTH_SIGN_IN)}
          >
            <Typography
              sx={{
                fontSize: "16px",
                textDecoration: "underline",
                textDecorationColor: "rgba(9, 69, 88, 0.4)",
              }}
            >
              既にアカウントをお持ちの方はこちら
            </Typography>
          </Button>
        </Box>
      </Card>
    </AuthLayout>
  );
};

export default Signup;
